import Model from './Model'
import User from "./User";
import Discipline from "./Discipline";

export default class TalentTeam extends Model {
    static Key = 'TalentTeam';


    static normalize(props) {

        props.talent_service_groups = props.talent_service_groups || [];
        props.positions = props.positions || [];
        props.pending_invites = props.pending_invites || [];

        if (props.banner_image && !props.banner_image_path) {
            props.banner_image_path = props.banner_image
        }
        if (props.positions?.length) {
            console.log('normalizeTalentTeampositions', props.positions.length);
            props.positions = TB.map(props.positions, position => {
                if (position.user) {
                    position.user = User.make({...position.user});
                }
                return {
                    ...position,
                    role: position.role === 'Base User' ? 'Member' : position.role
                };
            });
            props.positions = TB.orderBy([...props.positions], [pos => {
                if (pos.was_rejected) {
                    return 0
                }
                switch (pos.role) {
                    default:
                    case "Member":
                        return pos.has_joined ? 2 : 1;
                    case "Admin":
                        return 3;
                    case "Owner":
                        return 4;
                }
            }, 'user.is_available', 'user.is_active'], ['desc', 'desc', 'desc'])
        }
        if (props.pending_invites?.length) {
            props.pending_invites = TB.map(props.pending_invites, position => {
                if (TB.isObject(position.recipient) && position.recipient.first_name) {
                    position.user = User.make({...position.recipient});
                }else  if (TB.isString(position.recipient) || position.recipient?.email) {
                    position.email =position.recipient?.email ||position.recipient;
                    position.user = null;
                }
                return {
                    ...position,
                    role: position.role === 'Base User' ? 'Member' : position.role
                };
            });
        }


        if (props.positions) {
            props.positions = TB.map(props.positions, pos => {

                pos.disciplines = TB.filter(TB.map(pos.disciplines, discipline => {
                    let lookup = Discipline.find(discipline.discipline_id) || {}
                    if (!lookup) return null
                    return {
                        ...discipline,
                        name: lookup?.name
                    }
                }), dis => !!dis)

                return User.make({...pos})
            })
        }

        return props;
    }

    static FetchAllRequest;

    static async fetchAllTeamsForTalent(params = {}, requestOptions = {}) {
        const user = TB.auth().user();

        if (!user) {
            throw new Error('Unauthenticated')
        }

        if (!user.canManageTalent() && !user.isTalent() && !user.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }

        this.FetchAllRequest = TB.request(TB.api_endpoint(`/api/talent/teams`), params);

        const response = await this.FetchAllRequest.get(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.teams')) {
            if (user.canManageTalent()) {
                return TB.event("TalentTeam@FetchForTalentManagerFailed", this.FetchAllRequest)
            }
            throw new Error("Something went wrong")
        }


        const teams = TB.orderBy(TalentTeam.makeMany(response.success.data.teams), [team => team.teamMemberPositionForAuth(user)?.joined_at, 'is_invite'], ['desc', 'asc']);

        if (!user.canManageTalent()) {
            return teams;
        }
        let {
            current_page,
            last_page,
            total
        } = response.success.data;
        TB.event("TalentTeam@FetchForTalentManagerUpdated",
            {
                models: teams,
                current_page,
                last_page,
                total
            }
        )
    }

    static async fetchTeamForTalent(teamId, requestOptions = {}) {
        const user = TB.auth().user();

        if (!user) {
            throw new Error('Unauthenticated')
        }

        if (!user.canManageTalent() && !user.isTalent() && !user.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }

        this.FetchTalentTeamRequest = TB.request(TB.api_endpoint(`/api/talent/teams/${teamId}`));

        const response = await this.FetchTalentTeamRequest.get(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    static async fetchTeamForClient(teamId, queryString = '',requestOptions = {}) {
        const user = TB.auth().user();

        if (!user) {
            throw new Error('Unauthenticated')
        }

        if (user.isTalent()) {
            throw new Error('Unauthorized')
        }

        const client_id = user.clientOrg().id;

        this.FetchTeamRequest = TB.request(TB.api_endpoint(`/api/clients/${client_id}/teams/${teamId}${queryString}`));

        const response = await this.FetchTeamRequest.get(requestOptions).catch(console.warn);
        if(!response && this.FetchTeamRequest.didFinish && this.FetchTeamRequest.response.status === 404) {
            return false
        }else if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }


    static async fetchTeam(teamId, queryString = '',requestOptions = {}) {
        const user = TB.auth().user();

        if (!user) {
            throw new Error('Unauthenticated')
        }

        // if (!user.isTalent() && !user.canManageClientResourceTalent()) {
        //     throw new Error('Unauthorized')
        // }

        this.FetchTeamRequest = TB.request(TB.api_endpoint(`/api/teams/${teamId}${queryString}`));

        const response = await this.FetchTeamRequest.get(requestOptions).catch(console.warn);
        if(!response && this.FetchTeamRequest.didFinish && this.FetchTeamRequest.response.status === 404) {
            return false
        }else if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    static async create(props) {
        const user = TB.auth().user();

        if (!user) {
            throw new Error('Unauthenticated')
        }

        if (!user.canManageTalent() && !user.isTalent() && !user.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }
        if (user.isTalentSupplierResource()) {
            throw new Error('Unauthorized')
        }

        let params = TB.pick({...props}, ['is_available', 'name', 'bio', 'profile_links']);

        params.banner_image = this.banner_image_path;

        params.is_available = params.is_available ? 1 : 0;
        const createRequest = TB.request(TB.api_endpoint(`/api/talent/teams/store`), params).headers({
            'Content-Type': 'multipart/form-data'
        });

        const response = await createRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    invites() {
        return [...(this.pending_invites || []), ...(this.rejected_invites || [])]
    }

    async update(props) {
        const user = TB.auth().user();

        if (!user) {
            throw new Error('Unauthenticated')
        }

        if (!user.canManageTalent() && !user.isTalent() && !user.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }
        if (user.isTalentSupplierResource()) {
            throw new Error('Unauthorized')
        }

        let params = TB.pick({
            ...this,
            ...props
        }, ['is_available', 'name', 'bio', 'profile_links']);

        if (this.banner_image_path && !this.banner_image) {
            params.banner_image = this.banner_image_path
        }
        params.is_available = params.is_available ? 1 : 0;

        const updateRequest = TB.request(TB.api_endpoint(`/api/talent/teams/${this.id}/update`),params).headers({
            'Content-Type': 'multipart/form-data'
        });

        const response = await updateRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    async updateTeamServices(services) {
        const user = TB.auth().user();
        if (!user) {
            throw new Error('Unauthenticated')
        }

        if (!user.canManageTalent() && !user.isTalent() && !user.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }
        if (user.isTalentSupplierResource()) {
            throw new Error('Unauthorized')
        }

        services = TB.map(services, 'id');

        const syncServicesRequest = TB.request(
            TB.api_endpoint(`/api/talent/teams/${this.id}/update-services`),
            {talent_service_groups: services}
        );

        const response = await syncServicesRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    async updateTeamMembers(positions) {
        const user = TB.auth().user();
        if (!user) {
            throw new Error('Unauthenticated')
        }

        if (!user.isTalent() && !user.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }
        if (user.isTalentSupplierResource()) {
            throw new Error('Unauthorized')
        }

        if (!positions?.length) {
            throw new Error('Unauthorized')
        }
        positions = TB.map([...positions], position => TB.pick(position, [
            'id',
            'title',
            'is_featured',
            'display_index',
        ]));
        const updateMembersRequest = TB.request(
            TB.api_endpoint(`/api/talent/teams/${this.id}/update-members`),
            {positions}
        );


        const response = await updateMembersRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }
    async updateTeamLeads(positions) {
        const user = TB.auth().user();
        if (!user) {
            throw new Error('Unauthenticated')
        }

        if (!user.isTalent() && !user.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }
        if (user.isTalentSupplierResource()) {
            throw new Error('Unauthorized')
        }

        if (!positions?.length) {
            throw new Error('Unauthorized')
        }
        positions = TB.map(positions, position => {
            return {
                id: position.id,
                is_lead: position.is_lead ? 1 : 0
            }
        });
        const updateLeadsRequest = TB.request(
            TB.api_endpoint(`/api/talent/teams/${this.id}/update-members`),
            {positions}
        );


        const response = await updateLeadsRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    async requestApprovalForTeamServices(services) {
        const user = TB.auth().user();
        if (!user) {
            throw new Error('Unauthenticated')
        }

        if (!user.canManageTalent() && !user.isTalent() && !user.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }
        if (user.isTalentSupplierResource()) {
            throw new Error('Unauthorized')
        }

        if (!services?.length) {
            throw new Error('Unauthorized')
        }

        services = TB.map(services, 'id');

        const approvalRequest = TB.request(
            TB.api_endpoint(`/api/talent/teams/${this.id}/services/request-approval`),
            {talent_service_groups: services}
        );

        const response = await approvalRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }


    async requestHelpFillingDisciplines(disciplines = []) {
        const user = TB.auth().user();

        if (!user || !user.isTalent() || user.isTalentSupplierResource() || user.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }

        disciplines = TB.map(disciplines, 'id')

        const updateRequest = TB.request(
            TB.api_endpoint(`/api/talent/teams/${this.id}/disciplines/request-fill`),
            {disciplines}
        );

        const response = await updateRequest.post().catch(console.warn);

        if (!response || !TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        let previouslyRequested = TB.filter(TB.flatMap(this.talent_service_groups, 'disciplines'), {has_requested_fill:true});
        previouslyRequested = TB.map(previouslyRequested, 'name')
        let requested = [
            ...(previouslyRequested || []),
            ...(response.success.data.disciplines_requested || [])
        ];

        let talent_service_groups = TB.map(response.success.data.team?.talent_service_groups || [], service => {
            service.disciplines = TB.map(service.disciplines, discipline => {
                if (requested.includes(discipline.name)) {
                    discipline.has_requested_fill = true;
                }
                return discipline;
            })
            return service;
        })
        return TalentTeam.make({
            ...response.success.data.team,
            talent_service_groups
        });
    }

    async searchAllTalentForMemberInvite(params, requestOptions = {}) {
        const user = TB.auth().user();

        if ((!user || !user.isTalent() || user.isTalentSupplierResource() || user.canManageClientResourceTalent()) && !user.canManageTalent()) {
            throw new Error('Unauthorized')
        }

        const searchRequest = TB.request(
            TB.api_endpoint(`/api/talent/teams/${this.id}/talent-users/search-active-for-invite`),
            params
        );

        const response = await searchRequest.get(requestOptions).catch(console.warn);

        if(response?.status === 404) {
            return false
        } else if (!TB.has(response, 'success.data.users')) {
            throw new Error("Something went wrong")
        }
        return User.makeMany(response.success.data.users);
    }

    async inviteTalentMember(talentUser) {
        const user = TB.auth().user();

        if ((!user || !user.isTalent() || user.isTalentSupplierResource() || user.canManageClientResourceTalent()) && !user.canManageTalent()) {
            throw new Error('Unauthorized')
        }

        let talentUserDisciplines = TB.flatMap(talentUser.disciplines, 'discipline.id');

        let disciplines = TB.uniq(TB.map(TB.flatMap(this.talent_service_groups, 'disciplines'), 'id'));
        disciplines = TB.filter(disciplines, discipline => talentUserDisciplines.includes(discipline))

        const inviteMemberRequest = TB.request(
            TB.api_endpoint(`/api/talent/teams/${this.id}/talent-users/${talentUser.id}/invite`),
            {disciplines}
        );

        const response = await inviteMemberRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    async inviteExternalMember(email, disciplines = []) {
        const user = TB.auth().user();

        if ((!user || !user.isTalent() || user.isTalentSupplierResource() || user.canManageClientResourceTalent()) && !user.canManageTalent()) {
            throw new Error('Unauthorized')
        }

        disciplines = TB.uniq(TB.map(TB.flatMap(this.talent_service_groups, 'disciplines'), 'id'));

        const inviteExternalRequest = TB.request(
            TB.api_endpoint(`/api/talent/teams/${this.id}/external-invite`),
            {email, disciplines}
        );

        const response = await inviteExternalRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    async resendInvite(invite) {
        const user = TB.auth().user();

        if ((!user || !user.isTalent() || user.isTalentSupplierResource() || user.canManageClientResourceTalent()) && !user.canManageTalent()) {
            throw new Error('Unauthorized')
        }

        if (!this.pending_invites?.length || !TB.find(this.pending_invites, ['id', invite?.invite_id])) {
            throw new Error('Invite not found')
        }
        const resendInviteRequest = TB.request(TB.api_endpoint(`/api/talent/teams/${this.id}/invites/${invite?.invite_id}/resend-invite`));

        const response = await resendInviteRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    async cancelInvite(inviteId) {
        const user = TB.auth().user();

        if ((!user || !user.isTalent() || user.isTalentSupplierResource() || user.canManageClientResourceTalent()) && !user.canManageTalent()) {
            throw new Error('Unauthorized')
        }

        if (!this.invites().length || !TB.find(this.invites(), ['id', inviteId])) {
            throw new Error('Invite not found')
        }
        const cancelInviteRequest = TB.request(TB.api_endpoint(`/api/talent/teams/${this.id}/invites/${inviteId}/cancel-invite`));

        const response = await cancelInviteRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    async acceptTeamInvite() {
        const user = TB.auth().user();

        if (!user || !user.isTalent() || !this.invite_id) {
            throw new Error('Unauthorized')
        }

        const updateRequest = TB.request(TB.api_endpoint(`/api/talent/teams/${this.id}/invites/${this.invite_id}/accept`));

        const response = await updateRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    async rejectTeamInvite() {
        const user = TB.auth().user();

        if (!user || !user.isTalent() || !this.invite_id) {
            throw new Error('Unauthorized')
        }

        const updateRequest = TB.request(TB.api_endpoint(`/api/talent/teams/${this.id}/invites/${this.invite_id}/reject`));

        const response = await updateRequest.post().catch(console.warn);

        if (!response) {
            throw new Error("Something went wrong")
        }
        return true
    }

    async grantTeamMemberAdminRights(member) {
        const auth = TB.auth().user();
        const authMember = this.teamMemberPositionForAuth(auth);


        if (!auth.canManageClientResourceTalent() && (!authMember || !this.teamMemberHasAdminRights(authMember))) {
            throw new Error('Unauthorized')
        }
        if (!member?.user?.is_active) {
            throw new Error('Unauthorized')
        }

        const grantAdminRequest = TB.request(TB.api_endpoint(`/api/talent/teams/${this.id}/members/${member.user.id}/grant-admin-rights`));

        const response = await grantAdminRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    async revokeTeamMemberAdminRights(member) {
        const auth = TB.auth().user();
        const authMember = this.teamMemberPositionForAuth(auth);


        if (!auth.canManageClientResourceTalent() && (!authMember || !this.teamMemberHasAdminRights(authMember))) {
            throw new Error('Unauthorized')
        }
        if (!member?.user?.is_active) {
            throw new Error('Unauthorized')
        }

        const revokeAdminRequest = TB.request(TB.api_endpoint(`/api/talent/teams/${this.id}/members/${member.user.id}/revoke-admin-rights`));

        const response = await revokeAdminRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    async leaveTeam() {
        console.log('LEAVE TEAM')
        const user = TB.auth().user();

        if (!user) {
            throw new Error('Unauthenticated')
        }

        if (!user.isTalent() && !user.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }
        if (user.isTalentSupplierResource()) {
            throw new Error('Unauthorized')
        }

        if (user.isTalent() && this.is_owner) {
            throw new Error('Unauthorized')
        }

        const leaveTeamRequest = TB.request(TB.api_endpoint(`/api/talent/teams/${this.id}/leave`));

        const response = await leaveTeamRequest.post().catch(console.warn);

        if (!TB.has(response, 'success')) {
            throw new Error("Something went wrong")
        }

        return response;
    }

    async deleteTeam() {
        console.log('DELETE TEAM')
        const user = TB.auth().user();

        if (!user) {
            throw new Error('Unauthenticated')
        }

        if (!user.isTalent() && !user.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }
        if (user.isTalentSupplierResource()) {
            throw new Error('Unauthorized')
        }

        if (user.isTalent() && !this.is_owner) {
            throw new Error('Unauthorized')
        }

        const deleteTeamRequest = TB.request(TB.api_endpoint(`/api/talent/teams/${this.id}/delete`));

        const response = await deleteTeamRequest.post().catch(console.warn);

        if (!TB.has(response, 'success')) {
            throw new Error("Something went wrong")
        }

        return response;
    }


    async addTalentResourceMember(user_id) {
        let auth = TB.auth().user();
        if (!auth || !auth.canManageClientResourceTalent()) {
            throw new Error('Unauthorized')
        }

        const addTalentResourceMemberRequest = TB.request(
            TB.api_endpoint(`/api/talent/teams/${this.id}/members/${user_id}/add`),
            {role: TB.invert(laravel.team_user_roles)['Base User']}
        );

        const response = await addTalentResourceMemberRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    async removeTeamMember(member) {
        let auth = TB.auth().user();
        const authMember = this.teamMemberPositionForAuth(auth);

        if (!auth.canManageTalent() && !auth.canManageClientResourceTalent() && (
            !authMember || !this.teamMemberHasAdminRights(authMember) ||
            (authMember.role !== 'Owner' && this.teamMemberHasAdminRights(member))
        )) {
            throw new Error('Unauthorized')
        }

        const removeMemberRequest = TB.request(TB.api_endpoint(`/api/talent/teams/${this.id}/members/${member.user?.id}/remove`));

        const response = await removeMemberRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.team')) {
            throw new Error("Something went wrong")
        }
        return TalentTeam.make(response.success.data.team);
    }

    canManageTeamProfile() {
        let auth = TB.auth().user();
        const authMember = this.teamMemberPositionForAuth(auth);

        if (auth.isTalentSupplierResource()) {
            return false;
        }
        return !this.id
            || this.can_manage
            || (authMember && this.teamMemberHasAdminRights(authMember))
            || auth.canManageTalent()
            || (this.is_supplied_by_client && auth.canManageClientResourceTalent())
    }

    teamOwner() {
        return TB.find(this.positions, ['role', 'Owner'])
    }

    teamMemberHasAdminRights(member) {
        return ['Owner', 'Admin'].includes(member.role)
    }

    detailLink(isManaging = false) {
        let auth = TB.auth().user();
        let detailLinkPrefix = auth.canManageClientResourceTalent() ? 'supplier' : 'talent'
        if (auth.canManageTalent() && isManaging) {
            detailLinkPrefix = 'talent/manager'
        }


        return `/${detailLinkPrefix}/team/manage/${this.id}/control-center`
    }
    /*
    * Helper methods
    */
    statusDisplay() {
        if (this.is_invite) {
            return 'Invited'
        }else if(!this.is_approved) {
            return 'Pending Setup'
        }else if (!this.is_available) {
            return 'Approved/Inactive'
        }
        return 'Approved/Active'
    }

    teamMemberLeads() {
        let members = this.positions;//TB.filter(this.positions, ['has_joined', true]);
        members = TB.orderBy(members, 'display_index', 'desc')

        return members
    }
    teamMemberPositionForAuth(user) {
        if (!user) {
            user = TB.auth().user();
        }

        if (!user || !user.isTalent() || !this.positions?.length) {
            return false;
        }

        return TB.find(this.positions, ['user.id', user.id]);
    }

    membersForServiceDiscipline(discipline) {
        if (discipline.is_missing) {
            return false;
        }

        let positionMatches = TB.filter(this.positions, pos => TB.find(pos.user.disciplines, ['discipline.id', discipline.id]));

        if (!positionMatches.length) return false;

        return  TB.orderBy(positionMatches, ['is_lead'], 'desc');
    }

    servicesReadyForApproval() {
        return TB.filter(this.talent_service_groups || [], {has_missing_required_disciplines: false, is_approved: false, approval_requested: false})
    }
    servicesWaitingForApproval() {
        return TB.filter(this.talent_service_groups || [], {has_missing_required_disciplines: false, is_approved: false, approval_requested: true})
    }
    servicesNotReadyForApproval() {
        return TB.filter(this.talent_service_groups || [], {has_missing_required_disciplines: true, is_approved: false, approval_requested: false})
    }
    rolesFilledForServices() {
        let disciplines = TB.flatMap(this.talent_service_groups || [], 'disciplines');

        return TB.uniqBy(TB.filter(disciplines, {is_missing: false, is_optional: false}), 'id')
    }

    rolesMissingForServices() {
        let disciplines = TB.flatMap(this.talent_service_groups || [], 'disciplines');

        return TB.uniqBy(TB.filter(disciplines, {is_missing: true, is_optional: false}), 'id')
    }
}